webpackJsonp([15],{

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(502);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("9a511ea6", content, true, {});

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".body{margin:0 10%}.center{text-align:center}.tcTitle{font-weight:400}.sdgTitle{font-size:45px}.underLine{text-decoration:underline}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/TermsOfUse/TermsOfUse.vue"],"names":[],"mappings":"AACA,MACI,YAAc,CACjB,AACD,QACI,iBAAmB,CACtB,AACD,SACI,eAAmB,CACtB,AACD,UACI,cAAgB,CACnB,AACD,WACI,yBAA2B,CAC9B","file":"TermsOfUse.vue","sourcesContent":["\n.body {\n    margin: 0 10%;\n}\n.center {\n    text-align: center;\n}\n.tcTitle{\n    font-weight:normal;\n}\n.sdgTitle{\n    font-size: 45px;\n}\n.underLine{\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('h1',{staticClass:"tcTitle center"},[_vm._v("Terms of Use")]),_vm._v(" "),_c('h1',{staticClass:"sdgTitle center"},[_vm._v("SDG")]),_vm._v(" "),_c('p',[_vm._v("\n          Soli Deo Gloria Releasing, LLC (SDG) provides a transaction video on demand (TVOD) service streamed over the internet to certain internet-connected TV’s, computers, smartphones, and other devices. \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n              These Terms of Use govern your use of our Services, and your use of our Services constitutes your acceptance. Please review our Privacy Policy, the terms of which are incorporated herein. \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n              As part of these Terms of Use, you agree to arbitration as further described under the Arbitration Agreement section of these Terms of Use. \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n              Your use of the Services must follow all rules set forth in this agreement. You may use the Services only for personal, noncommercial purpose. You may not tamper with, edit, cut, or any in any way alter the content provided by Services. You may not tamper with, modify or alter any software used with the Services. \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n              Some Services may be offered to others on terms different or more favorable than yours with respect to pricing or otherwise, and no refunds or claims can be made by you against SDG on the basis thereof. \n\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n              In order to use our Services, you must provide payment. You authorize us to charge any Payment Method for which you enter the basic information, provided that you have also chosen one or more videos for transactional rental, download and/or purchase. If a payment does not successfully settle, due to expiration, insufficient funds, or otherwise, we have no further obligation to provide Services, unless and until satisfactory remittance is made by you and received by SDG. \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n              Since our Services are purely transactional in nature, you are under no subscription agreement or obligation to purchase additional Services, or to continue viewing additional content based on prior purchase/s. You may also find billing information about your transaction/s by visiting your account with the applicable third party. \n      ")]),_vm._v(" "),_c('p',{staticClass:"underLine"},[_vm._v("\n              Changes to Pricing and Plans; No refunds\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n              We reserve the right to change our Services or adjust pricing for our Services or any components thereof, at any time and in our sole discretion. All payments are nonrefundable and there are no refunds or credits for partially viewed videos. \n      ")]),_vm._v(" "),_c('p',{staticClass:"underLine"},[_vm._v("\n              Age requirement; personal use only\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n              You must be 18 years of age, or the age of majority in your country, state, province or territory      (as appropriate) in order to use our Services.  Our Services are for your personal, non-commercial use only, and may not be shared with individuals outside of your immediate household. \n      ")]),_vm._v(" "),_c('p',{staticClass:"underLine"},[_vm._v("\n              Geo-restrictions; no downloading; \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n              Some content may be geo-restricted, and not available in your particular country or territory due to licensing restrictions. Content may also be available for temporary download and offline viewing on certain supported devices. You agree not to archive, download, reproduce, distribute, modify, publish, offer for sale or otherwise use content or our Services. \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n              The quality of our Services may vary from device to device, and territory to territory, and may be affected by a number of factors including your location, your telecommunications service, cable and/or digital service provider, the bandwidth of your internet connection, and the level of resolution required or preferred by local telecommunications providers. Not all content is available in all formats. You are responsible for all internet access charges. Please check with your internet provider for all internet access charges. SDG makes no representations or warranties about the quality of your of your viewing experience on your particular display. \n              Only the person whose payment method is charged has access over usage of our Services.\n              \n      ")]),_vm._v(" "),_c('p',{staticClass:"underLine"},[_vm._v("Disclaimers and Limitations on Liability")]),_vm._v(" "),_c('p',[_vm._v("\n              Our Services are provided ‘as is’ with all faults and without warranty/ies of any kind. To the extent permissible under applicable law/s, in no event shall SDG, its subsidiaries, directors, officers, employees, shareholders or licensors be liable (either jointly or severally) to you for any personal injury or any form of damages whatsoever, including without limitation special, incidental, indirect or consequential damages of any kind, or any damages whatsoever. \n      ")]),_vm._v(" "),_c('p',{staticClass:"underLine"},[_vm._v("Arbitration Agreement")]),_vm._v(" "),_c('p',[_vm._v("\n              By using our Services, you agree to that any dispute, claim or controversy arising out of or relating in any way to your use of our Services, shall be determined by binding arbitration. You agree that, by agreeing to these Terms of Use, the U.S. Federal Arbitration Act governs the interpretation and enforcement of this provision. You agree to the exclusive use of arbitration in the state of California, county of Los Angeles. \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n              Arbitration will be governed by the Commercial Arbitration Rules (“AAA Rules”) of American Arbitration Association. Any arbitrator’s award shall be final and binding on all parties, except for judicial review expressly permitted by law, or the arbitrator’s award includes an award of injunctive relief against SDG. You agree that you may bring action against SDG only as an individual, and not as a plaintiff or class member in any purported class or representational proceeding. You agree not to allow the arbitrator to consolidate any other person’s claims with your claim/s. If this specific provision is found to be unenforceable, then the entirety of this arbitration provision shall be null and void.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n              In the event that this provision is found to be unenforceable for any reason whatsoever, you agree to the exclusive jurisdiction of the state and Federal courts in the state of California, county of Los Angeles.\n      ")]),_vm._v(" "),_c('p',{staticClass:"underLine"},[_vm._v("Customer Support")]),_vm._v(" "),_c('p',[_vm._v("\n              Because of the international nature of our Services, customer support in individual territories, languages, etc. is commercially impractical. We will do our best to resolve any issues, but you understand and agree that this may not be possible. Refund of your payment/s to date for our Services shall be considered full settlement for any claims which fall short of the threshold reasonably necessary for arbitration. \n      ")]),_vm._v(" "),_c('p',{staticClass:"underLine"},[_vm._v("Governing Law & Survival")]),_vm._v(" "),_c('p',[_vm._v("\n              These Terms of Use shall be governed by and construed in accordance with the laws of the state of California, USA without regard to conflict of laws provisions. These terms will not limit any consumer protection rights that you may be entitled to under the mandatory laws of your state or country of residence. If any provision of these Terms of Use is held to be invalid, illegal or unenforceable, remaining provisions shall nonetheless remain in full force and effect.\n      ")]),_vm._v(" "),_c('p',{staticClass:"underLine"},[_vm._v("Change/s to Terms of Use; Assignment")]),_vm._v(" "),_c('p',[_vm._v("\n              SDG may change these terms of use from time to time, and such changes shall be effective immediately. Since the nature of our Services is purely transactional, and subject to the Terms of Use at the time of purchase, no notice of such change shall be required to be made to you. We may assign your agreement with you to any affiliated company, or to any entity or business partner with which or through which we offer our Services.\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfUse_vue__ = __webpack_require__(347);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b15d17e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfUse_vue__ = __webpack_require__(503);
function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsOfUse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b15d17e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsOfUse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/15.d781701585d76e0a8ca0.js